import AxiosClient from '@services/api/base'
import { Course } from 'types/course'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

const getAuthorCourses = (): Promise<Course[]> => {
  const tokenId = Cookies.get(AUTH_TOKEN_KEY)
  return new Promise((resolve, reject) => {
    const URL = routes.AUTHOR_COURSES
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }

    AxiosClient.get(URL, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject("Error fetching Author's Courses: " + err)
      })
  })
}

export default getAuthorCourses
